import { z } from 'zod'

import {
  accountFormDefaultValues,
  ZAccountForm,
} from '@/features/update-account/@x/sign-up'
import {
  receiptInformationDefaultValues,
  ZReceiptInformationForm,
} from '@/features/update-receipt-information/@x/sign-up'

export const defaultValues: TSignUpHostConversionForm = {
  hostIntro: '',
  ...accountFormDefaultValues,
  ...receiptInformationDefaultValues,
  recommenderPhoneNumber: '',
}

export const ZSignUpHostConversionForm = ZAccountForm.pick({
  accountHolder: true,
})
  .merge(ZReceiptInformationForm)
  .extend({
    hostIntro: z.string().min(1, '임대인 소개를 입력해 주세요.'),
    bankName: z.string().trim(),
    bankAccount: z.string().trim(),
    recommenderPhoneNumber: z.string().optional(),
  })

export type TSignUpHostConversionForm = z.infer<
  typeof ZSignUpHostConversionForm
>
